import { createContext } from "react";

const ShoppingSiteContext = createContext(null);

export default ShoppingSiteContext;
